import { Link, useLocation } from 'react-router-dom';
import { Home, Upload, Pill, Activity } from 'lucide-react';
import { motion } from 'framer-motion';

export const Header: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/upload', label: 'Upload', icon: Upload },
    { path: '/cabinet', label: 'Cabinet', icon: Pill },
  ];

  return (
    <header>
      <nav className="container">
        <Link to="/" className="logo">
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: 360 }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          >
            <Activity size={32} strokeWidth={2.5} />
          </motion.div>
          <span>MedCheck</span>
        </Link>
        <ul className="nav-links">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={isActive(item.path) ? 'active' : ''}
                >
                  <Icon size={18} />
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </header>
  );
};
